import paymentHistory from './paymentHistory'
export const paymentHistoryService = paymentHistory

